import { useContext } from "react";
import { AppContext } from "../../../App";
import {
  getAllPracticesFromClient,
  getClientFromPracticesSelected,
} from "../../pages/Connections/connections.middleware";

const formatPractices = (practices) => {
  return practices.map((practice) => {
    return {
      value: practice._id,
      label: practice.name,
    };
  });
};

const useSelectPractices = () => {
  const appContext = useContext(AppContext);
  const allPractices = appContext.get("practices");
  const practices = formatPractices(allPractices);

  return {
    practices,
  };
};

export default useSelectPractices;
